import { FC } from 'react';
import { BuildInAppToolId, IAppToolProps } from '../../../types/appTools';
import AppTool from './AppTool';
import AdaChatWrapper from '../../Wrapper/AdaChatWrapper/AdaChatWrapper';
import AdaChatToolEnabled from '../../../toolsEnabled/AdaChatToolEnabled';

const AdaChatTool: FC<IAppToolProps> = ({
    selectedApp,
    isExpanded,
    shouldShowCollapseAnimation,
    shouldShowExpandAnimation,
}) => (
    <AdaChatToolEnabled>
        {({ isLoading, isEnabled }) => (
            <AppTool
                selectedApp={selectedApp}
                appTool={BuildInAppToolId.SupportChat}
                isEnabled={isEnabled}
                isLoading={isLoading}
            >
                <AdaChatWrapper
                    isExpanded={isExpanded}
                    selectedApp={selectedApp}
                    shouldShowCollapseAnimation={shouldShowCollapseAnimation}
                    shouldShowExpandAnimation={shouldShowExpandAnimation}
                />
            </AppTool>
        )}
    </AdaChatToolEnabled>
);

export default AdaChatTool;
